import { useEffect, useState } from 'react';

const OFFER_SECONDS = 22 * 60 + 22;
// Shared deadline so every timer on the page stays in sync.
const DEADLINE = Date.now() + OFFER_SECONDS * 1000;

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = Math.max(0, Math.round((DEADLINE - now) / 1000));

  return {
    mm: Math.floor(remaining / 60),
    ss: remaining % 60,
    deadline: new Date(DEADLINE),
    expired: remaining === 0,
  };
}
